import { useState } from 'react';
import {
    Box, Button, Chip, FormControl, FormLabel, Input, Stack,
} from '@mui/joy';
import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded';


const PRESETS = [
    { value: 'today', label: 'Сегодня' },
    { value: 'yesterday', label: 'Вчера' },
    { value: '7d', label: '7 дней' },
    { value: '30d', label: '30 дней' },
    { value: '90d', label: '90 дней' },
];


/**
 * Выбор периода. Пресеты покрывают почти все случаи, произвольные даты
 * прячутся до нажатия — иначе панель фильтров занимает пол-экрана
 * ради того, чем пользуются раз в месяц.
 */
export default function AdPeriodPicker({ value, onChange }) {
    const [custom, setCustom] = useState(!!(value?.dateFrom || value?.dateTo));
    const [from, setFrom] = useState(value?.dateFrom || '');
    const [to, setTo] = useState(value?.dateTo || '');

    const applyPreset = (period) => {
        setCustom(false);
        setFrom(''); setTo('');
        onChange({ period, dateFrom: null, dateTo: null });
    };

    const applyCustom = () => {
        if (!from && !to) return;
        onChange({ period: null, dateFrom: from || null, dateTo: to || null });
    };

    return (
        <Box>
            <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap alignItems="center">
                {PRESETS.map((preset) => (
                    <Chip
                        key={preset.value}
                        variant={!custom && value?.period === preset.value ? 'solid' : 'outlined'}
                        color={!custom && value?.period === preset.value ? 'primary' : 'neutral'}
                        onClick={() => applyPreset(preset.value)}
                        sx={{ cursor: 'pointer' }}
                    >
                        {preset.label}
                    </Chip>
                ))}
                <Chip
                    variant={custom ? 'solid' : 'outlined'}
                    color={custom ? 'primary' : 'neutral'}
                    startDecorator={<DateRangeRoundedIcon sx={{ fontSize: 16 }} />}
                    onClick={() => setCustom((v) => !v)}
                    sx={{ cursor: 'pointer' }}
                >
                    Свой период
                </Chip>
            </Stack>

            {custom && (
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.2}
                       alignItems="flex-end" sx={{ mt: 1.5 }}>
                    <FormControl size="sm">
                        <FormLabel>С даты</FormLabel>
                        <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
                    </FormControl>
                    <FormControl size="sm">
                        <FormLabel>По дату</FormLabel>
                        <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
                    </FormControl>
                    <Button size="sm" onClick={applyCustom}>Применить</Button>
                </Stack>
            )}
        </Box>
    );
}